const resources = {
    title: 'Erreur',
    confirmButton: 'OK',
    noQualify: 'Vous n’êtes pas admissible à cet article, conformément à nos',
    termsAndConditions: 'MODALITÉS'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
